import { useQuery } from '@tanstack/react-query';

import { authFetch } from '@verantos-dev/core-utils';
import type { ObjectResponse } from '@verantos-dev/types-common';

import { analyticalDatasetKeys } from './queryKeys';
import type { AnalyticalDatasetVersion } from './types';

interface UseAnalyticalDatasetVersionQueryArgs {
  projectId: string;
  analyticalDatasetProfileId: string;
  analyticalDatasetVersionId: string;
}

export const useAnalyticalDatasetVersionQuery = ({
  projectId,
  analyticalDatasetProfileId,
  analyticalDatasetVersionId,
}: UseAnalyticalDatasetVersionQueryArgs) => {
  return useQuery({
    queryKey: analyticalDatasetKeys.version(analyticalDatasetVersionId),
    queryFn: () =>
      authFetch<ObjectResponse<AnalyticalDatasetVersion>>(
        `/analytical-datasets/${encodeURIComponent(projectId)}` +
          `/analytical-dataset-profile/${encodeURIComponent(analyticalDatasetProfileId)}` +
          `/analytical-dataset-version/${encodeURIComponent(analyticalDatasetVersionId)}`
      ),
    enabled:
      projectId.length > 0 &&
      analyticalDatasetProfileId.length > 0 &&
      analyticalDatasetVersionId.length > 0,
    retry: false,
  });
};
